<form
  novalidate
  [formGroup]="form"
  class="auth-form"
  (ngSubmit)="isVerifyOtpVisible ? verifyOtp() : requestOtp()"
  data-qa="form"
>
  <div class="form-row" *ngIf="isVerifyOtpVisible">
    <div class="mat-subheading-2">{{ 'user.request_verify_phone' | translate }}</div>
    <div class="body-1">{{ 'user.otp_sent' | translate }} {{ userPhoneNumber }}</div>
    <mat-form-field appearance="fill">
      <mat-label>{{ 'user.otp' | translate }}</mat-label>
      <input matInput formControlName="otp" required />
      <mat-error [data-qa]="'invalid-otp-error'" *ngIf="form.get('otp')?.invalid">{{
        getErrorMessage('otp')
      }}</mat-error>
    </mat-form-field>
    <mat-error [data-qa]="'otp-verification-error'">{{ loginError }}</mat-error>
    <ng-container *ngIf="!isCountdownEnded; else requestNewOtp">
      <div class="request-new-otp">
        {{ 'user.otp_countdown' | translate }}
        <app-countdown-timer
          [deadline]="otpDeadline"
          (countdownFinished)="onOtpCountdownEnd()"
        ></app-countdown-timer>
      </div>
    </ng-container>
    <ng-template #requestNewOtp>
      <div class="request-new-otp">
        <mzima-client-button fill="clear" size="small" (buttonClick)="requestOtp()"
          ><span class="retry-request-otp">{{
            'user.request_new_otp' | translate
          }}</span></mzima-client-button
        >
      </div>
    </ng-template>
  </div>

  <div class="phone-wrapper" *ngIf="authType === 'phone' && !isVerifyOtpVisible">
    <div class="form-row input-with-prefix">
      <mat-form-field appearance="fill" class="field-flex">
        <mat-label>{{ 'user.phone' | translate }}</mat-label>
        <input
          matInput
          formControlName="phone"
          required
          [data-qa]="'phone'"
          (keydown.enter)="
            form.controls['phone'].invalid || form.disabled || submitted ? null : requestOtp()
          "
        />
        <mat-error [data-qa]="'invalid-phone-error'" *ngIf="form.get('phone')?.invalid">{{
          getErrorMessage('phone')
        }}</mat-error>
      </mat-form-field>
    </div>
    <div class="form-row input-prefix">
      <app-country-code-selector (countrySelected)="onCountrySelected($event)">
      </app-country-code-selector>
    </div>
  </div>
  <div class="form-row" *ngIf="authType === 'password'">
    <mat-form-field appearance="fill">
      <mat-label>{{ 'user.email' | translate }}</mat-label>
      <input matInput formControlName="email" required [data-qa]="'email'" />
      <mat-error [data-qa]="'invalid-email-error'" *ngIf="form.get('email')?.invalid">{{
        getErrorMessage('email')
      }}</mat-error>
    </mat-form-field>
  </div>

  <div class="form-row" *ngIf="authType === 'password'">
    <mat-form-field appearance="fill">
      <mat-label>{{ 'user.password' | translate }}</mat-label>
      <input
        matInput
        formControlName="password"
        required
        [type]="isPasswordVisible ? 'text' : 'password'"
        [data-qa]="'password'"
      />
      <mat-error [data-qa]="'invalid-password-error'" *ngIf="form.get('password')?.invalid">{{
        getErrorMessage('password')
      }}</mat-error>
      <mzima-client-button
        matSuffix
        fill="clear"
        color="secondary"
        [iconOnly]="true"
        (buttonClick)="togglePasswordVisible()"
        [data-qa]="'toggle-password'"
      >
        <mat-icon icon [svgIcon]="isPasswordVisible ? 'eye-open' : 'eye'"></mat-icon>
      </mzima-client-button>
    </mat-form-field>
    <mat-error [data-qa]="'invalid-credential-error'">{{ loginError }}</mat-error>
  </div>

  <div class="form-row controls" *ngIf="authType === 'password'">
    <mzima-client-button
      (buttonClick)="restorePassword()"
      fill="clear"
      [data-qa]="'restorePassword'"
    >
      {{ 'nav.forgotyourpassword' | translate }}
    </mzima-client-button>
  </div>

  <div mat-dialog-actions align="end">
    <ng-content
      select="[btn-cancel]"
      *ngIf="!isVerifyOtpVisible || authType === 'password'"
    ></ng-content>

    <mzima-client-button
      *ngIf="isVerifyOtpVisible"
      (buttonClick)="goBack()"
      fill="outline"
      color="secondary"
    >
      {{ 'app.back' | translate }}
    </mzima-client-button>

    <mzima-client-button
      *ngIf="!isVerifyOtpVisible"
      (buttonClick)="requestOtp()"
      [disabled]="form.controls['phone'].invalid || form.disabled || submitted"
    >
      {{ 'nav.login' | translate }}
    </mzima-client-button>

    <mzima-client-button
      *ngIf="isVerifyOtpVisible"
      type="submit"
      [disabled]="form.invalid || form.disabled || submitted"
      [data-qa]="'btn-login'"
      id="btn-login"
    >
      {{ 'app.verify' | translate }}
    </mzima-client-button>
  </div>
</form>
